import { Exclude } from 'class-transformer';

export class WorkOrderVendorListResultDto {
    vendorId: number;
    vendorName: string;
    vendorType: string;
    address: string;
    isActive: boolean;

    @Exclude()
    proposalVendorType: string;
}
